document.addEventListener('DOMContentLoaded', function () {
  // carousel controls
  const prevButton = document.getElementById('prev');

  const nextButton = document.getElementById('next');

  // end carousel controls

  // carousel variables
  const carousel = document.querySelector('.video_testimonials_carousel');

  const container = document.querySelector('#video_testimonials');

  const computedStyle = window.getComputedStyle(container);

  const containerWidth = container.offsetWidth;

  const testimonialWidth = document.querySelector('#video_textimonial').offsetWidth;

  let container_pad_left = computedStyle.paddingLeft;

  container_pad_left = container_pad_left.slice(0, container_pad_left.length - 2);

  let num_containers = Math.floor(containerWidth / testimonialWidth);
  num_containers = num_containers == 1 ? 1 : num_containers - 1;

  let currentPosition = 0;

  // end carousel variables

  // prev button logic

  prevButton.addEventListener('click', function () {
    currentPosition += testimonialWidth * num_containers + (num_containers - 1) * 32 + parseInt(container_pad_left);

    if (currentPosition > 0) {
      currentPosition = 0;
    }

    // this line moves the carousel the others just calculate stuff
    carousel.style.transform = `translateX(${currentPosition}px)`;
  });

  // next button logic

  nextButton.addEventListener('click', function () {
    currentPosition -= testimonialWidth * num_containers + (num_containers - 1) * 32 + parseInt(container_pad_left);

    const maxPosition = -(carousel.offsetWidth - containerWidth + parseInt(container_pad_left));
    if (currentPosition < maxPosition) {
      currentPosition = maxPosition;
    }

    // this line moves the carousel the others just calculate stuff
    carousel.style.transform = `translateX(${currentPosition}px)`;
  });
});

// this stuff is dealing with play and pause button for videos

// should consider adding video play and pause aswell maybe?

document.addEventListener('DOMContentLoaded', function () {
  const playButtons = document.querySelectorAll('.play_button');
  const pauseButtons = document.querySelectorAll('.pause_button');
  const videos = document.querySelectorAll('.video');

  playButtons.forEach((playButton, index) => {
    playButton.addEventListener('click', function () {
      playButton.style.display = 'none';
      pauseButtons[index].style.display = 'block';
      videos[index].play();
    });
  });

  pauseButtons.forEach((pauseButton, index) => {
    pauseButton.addEventListener('click', function () {
      pauseButton.style.display = 'none';
      playButtons[index].style.display = 'block';
      videos[index].pause();
    });
  });
});
